import {CarouselImage} from '../components/marketing-cc/ConfigData';

export enum THEME {
  VW22 = 'VW22',
  LNF22 = 'LNF22',
  AUDI23 = 'AUDI23',
  SKODA23 = 'SKODA23',
  CUPRA24 = 'CUPRA24',
  SEAT24 = 'SEAT24',
}

export enum BRAND {
  VW = "V",
  SEAT = "S",
  LNF = "L",
  AUDI = "A",
  SKODA = "C",
}

export enum ImageLoadingStatus {
  loading,
  success,
  error
}

export enum ImageType {
  exterior = 'exterior',
  interior = 'interior',
}

export interface SliderImageInfoOptions {
  alt?: string;
  cssClasses?: Set<string>;
  imgType?: ImageType;
}

export class RotationImage {
  public url: string;
  public loadingStatus: ImageLoadingStatus;
  public loadIndex: number;

  constructor(url: string) {
    this.url = url;
  }
}

export class SliderImageInfo {
  public src: string;
  public width: number;
  public height: number;

  public originalIndex: number;
  public loadIndex: number;
  public loadingStatus: ImageLoadingStatus;

  public cssClasses?: Set<string>;
  public alt?: string;
  public type?: ImageType;


  constructor(carouselImage?: CarouselImage, cssClasses?: Set<string>) {
    this.src = carouselImage?.url;
    this.width = carouselImage?.width;
    this.height = carouselImage?.height;

    this.cssClasses = cssClasses || new Set<string>();

    this.type = null;

    if (carouselImage?.interior) {
      this.type = ImageType.interior;
    }
    if (carouselImage?.interior === false) {
      this.type = ImageType.exterior;
    }

    if (this.type){
      this.cssClasses.add(this.type);
    }
  }

  get classList() {
    const cssClassObject: Record<string, boolean> = {};
    this.cssClasses?.forEach((value) => cssClassObject[value] = true);
    return cssClassObject;
  }
}
